import {BasicCriteria} from '../../framework/parameters/BasicCriteria';

export class UserApplicationCriteria extends BasicCriteria {
userId: number | null;
visionCode: string;
}

